<template>
  <div :class="['cargo-type-component', { 'disabled':!isEditable }]">
    <v-row align="center">
      <v-col class="text-center pt-3" sm="6" md="1">
        <v-menu offset-y :disabled="!isEditable">
          <template v-slot:activator="{ on }">
            <div v-on="on" ripple :style="isEditable?'cursor: pointer':''">
              <!-- <v-icon large>fas fa-archive</v-icon> -->
              <!-- <h3>{{$t('orders.' + cargoItem.type)}}</h3> -->
              <h3>{{$t('packages_type.' + cargoItem.type)}}</h3>
            </div>
          </template>
          <v-list class="pa-0">
            <div
              :class="[{'selected': cargoItem.type===item},'package-list-select']"
              v-for="(item, index) in packageTypes"
              :key="index"
              @click="cargoItem.type = item"
            >
              {{$t('packages_type.' + item)}}
            </div>
          </v-list>
        </v-menu>
      </v-col>
      <v-col class="text-center hidden-md-and-up" align-self="center" md="6">
        <v-btn text icon color="kazan" v-on:click="cloneCargoType(cargoItem)">
          <v-icon>fas fa-clone</v-icon>
        </v-btn>
        <v-btn text icon color="kazan" v-on:click="removeCargoType(index)">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="6" sm="4" md="2">
            <label for="length">{{$t('orders.length')}} *</label>
            <v-text-field
              v-model="cargoItem.length"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
              :disabled="!isEditable"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="width">{{$t('orders.width')}} *</label>
            <v-text-field
              v-model="cargoItem.width"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
              :disabled="!isEditable"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="height">{{$t('orders.height')}} *</label>
            <v-text-field
              v-model="cargoItem.height"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
              :disabled="!isEditable"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="weight">{{$t('orders.weight')}} *</label>
            <v-text-field
              v-model="cargoItem.weight"
              solo
              single-line
              suffix="kg"
              type="number"
              :rules="cargoRules"
              :disabled="!isEditable"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4">
            <label for="ref">{{$t('general.reference')}}</label>
            <v-text-field
              v-model="cargoItem.ref"
              solo
              single-line
              :disabled="!isEditable"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="hidden-sm-and-down pl-0" align-self="center" md="1" v-if="isEditable">
        <v-btn text icon color="kazan" @click="cloneCargoType()">
          <v-icon>fas fa-clone</v-icon>
        </v-btn>
        <v-btn text icon color="kazan" @click="removeCargoType()">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OrderFormCargoItem',
  props: ['cargoItem', 'index', 'isEditable'],
  data () {
    return {
      mesurmentUnits: ['cm', 'm'],
      weightUnits: ['kg', 't'],
      cargoRules: [
        v => !!v || this.$i18n.t('general.required_field'),
        v => v > 0 || this.$i18n.t('general.greater_then_zero')
      ],
      // packageTypes: ['box', 'pallet', 'bale', 'barrel', 'carton', 'crate', 'roll', 'package', 'bag', 'drum', 'bundle']
      packageTypes: ['box', 'pallet']
    }
  },
  methods: {
    removeCargoType: function () {
      this.$emit('remove-cargo', this.index)
    },
    cloneCargoType: function () {
      this.$emit('clone-cargo', this.cargoItem)
    }
  }
}
</script>

<style lang="scss" scoped>
    .cargo-type-component {
        padding: 15px 0;
        border-bottom: 1px solid #e2e2e2;
        margin-bottom: 10px;
    }
    .cargo-type-component h3 {
        margin-top: 4px;
    }
    .mesurment-units-selector {
        margin-top: 20px;
    }
    button {
        margin-left: 0;
        margin-right: 0;
    }
    .stockable-tooltip-btn {
        margin: 0 0 0 0;
        height: 22px;
        width: 22px;
    }
    ::v-deep .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
      padding: 0 6px;
    }
    ::v-deep .v-text-field__suffix {
      font-size: 10px;
    }

    ::v-deep .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }

    .package-list-select {
      cursor: pointer;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 16px;
      height: 30px;
      padding: 0 16px;

      &:not(:last-child) {
        border-bottom: 1px solid lightgray;
      }

      &:hover {
        background-color: lightgray;
      }

      &.selected {
        background-color: lightgray;
        font-weight: 600;
      }
    }
    .cargo-type-component {
      &.disabled {
        ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
          background-color: #ededed;

          .v-input__append-inner {
            display: none;
          }
        }
        ::v-deep .theme--light.v-input--is-disabled .v-label, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
          color: rgba(0, 0, 0, 0.87);
        }
        ::v-deep input {
          color: rgba(0, 0, 0, 0.87);
        }
        ::v-deep .v-select__selection {
          color: rgba(0, 0, 0, 0.87);
        }
      }
    }

</style>
